import * as React from "react";
import { iconExists } from "@grandvisionhq/icons";
import { parseHtml } from "@grandvisionhq/lib-utils-html";
import { parseLink } from "@grandvisionhq/state";
import { DateUtils } from "@grandvisionhq/utils";
import { useRoutingContext } from "../../../../../pages/BookAppointment/context/RoutingContext/v3/pages/BookAppointment/context/RoutingContext/context.js";
import { isWithinTimeSpan } from "../../../../../utils/v3/utils/datetime.js";
import CampaignInfoBanner from "./CampaignInfoBanner.js";
const CampaignInfoBannerContainer = ({
  startEndDateCompound,
  bannerIcon,
  bannerTitle,
  ...rest
}) => {
  const [, { routerId, currentRoute }] = useRoutingContext();
  const text = React.useMemo(
    () => bannerTitle && parseHtml(parseLink(bannerTitle, true)),
    [bannerTitle]
  );
  const showBanner = React.useMemo(() => {
    if (routerId !== "book-appointment" || !["", "where", "what", "when", "who"].includes(currentRoute) || !text || !startEndDateCompound?.startDate || !startEndDateCompound?.endDate) {
      return false;
    }
    const currentTime = /* @__PURE__ */ new Date();
    const startDate = new Date(startEndDateCompound.startDate);
    const endDate = new Date(startEndDateCompound.endDate);
    if (!DateUtils.isValidDateRange(startDate, endDate)) {
      return false;
    }
    return isWithinTimeSpan(currentTime, startDate, endDate);
  }, [startEndDateCompound, text, routerId, currentRoute]);
  const displayIcon = React.useMemo(() => bannerIcon && iconExists(bannerIcon), [bannerIcon]);
  if (showBanner === false || !text) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(CampaignInfoBanner, { icon: displayIcon ? bannerIcon : void 0, text, ...rest });
};
export {
  CampaignInfoBannerContainer as default
};
//# sourceMappingURL=CampaignInfoBannerContainer.js.map
